<template>
  <div>
    <ViewTemplateWithSalveCancel :panel="panel">
      <div slot="content-buttons">
        <Button v-if="id" _key="btnSupplierCreate" title="Fornecedor" classIcon="fas fa-plus-circle" type="primary"
          size="small" eventName="supplierCreate" :clicked="create" />
      </div>
      <div slot="content-main">
        <CustomerSupplierCreateUpdate :formName="panel.formName" _source="supplier" />
      </div>
    </ViewTemplateWithSalveCancel>
  </div>
</template>

<script>
import ViewTemplateWithSalveCancel from "@nixweb/nixloc-ui/src/component/template/ViewTemplateWithSalveCancel";
import CustomerSupplierCreateUpdate from "../../../components/modules/shared/customer-supplier/CustomerSupplierCreateUpdate.vue";

import Button from "@nixweb/nixloc-ui/src/component/forms/Button";
import Molded from "@nixweb/nixloc-ui/src/component/layout/Molded";

import { mapGetters, mapMutations } from "vuex";

export default {
  name: "CustomerSupplierCreateView",
  components: {
    Button,
    Molded,
    ViewTemplateWithSalveCancel,
    CustomerSupplierCreateUpdate,
  },
  data() {
    return {
      id: this.$route.params.id,
      panel: {
        module: "Fornecedor",
        title: "Fornecedor",
        formName: "customerSupplierCreateUpdate",
        showFilter: false,
        showSearch: false,
        showButtons: true,
      },
    };
  },
  computed: {
    ...mapGetters("generic", ["event"]),
  },
  methods: {
    ...mapMutations("generic", ["removeLoading"]),
    create() {
      this.$router.push({
        name: "supplierCreate",
      });
      this.removeLoading(["btnSupplierCreate"]);
    },
  },
};
</script>
